var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_632_1242)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16.64,
    fill: "url(#paint0_linear_632_1242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.499968 56.6173C0.499969 70.6677 9.18016 79.1982 18.112 79.1982C23.3782 79.1982 27.4202 76.9401 32.5661 76.9401C37.712 76.9401 41.4519 79.1982 45.7879 79.1982C50.3167 79.1982 63.3999 77.3165 63.3999 56.6173C63.3999 35.9181 51.213 24.0003 43.5235 24.0003C37.0606 24.0003 36.2271 29.0183 32.5789 29.0183C28.9307 29.0183 28.4275 24.0003 21.7601 24.0003C10.8156 24.0003 0.499966 42.5669 0.499968 56.6173Z",
    fill: "url(#paint1_radial_632_1242)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_f_632_1242)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.125,
    cy: 48.6125,
    rx: 18.975,
    ry: 17.7375,
    fill: "url(#paint2_radial_632_1242)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.4571,
    cy: 45.1809,
    rx: 1.92551,
    ry: 3.20918,
    fill: "#162430"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.7265,
    cy: 45.1809,
    rx: 1.92551,
    ry: 3.20918,
    fill: "#162430"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_632_1242",
    x: 7.64998,
    y: 25.375,
    width: 48.95,
    height: 46.4751,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.75,
    result: "effect1_foregroundBlur_632_1242"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_632_1242",
    x1: 32,
    y1: -33.5,
    x2: 32,
    y2: 36.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403846,
    stopColor: "#A4A4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985577,
    stopColor: "#7878FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_632_1242",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9499 44.4878) rotate(90) scale(34.7875 39.6416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C2F7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47658,
    stopColor: "#BCF0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FE5CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_632_1242",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9732 42.6527) rotate(89.7053) scale(29.5156 31.5747)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAFFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7EEE1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_632_1242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16.64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogo);
export default __webpack_public_path__ + "static/media/icon-logo.fb57b50fce8b0fb5d365c1a2420f8f6b.svg";
export { ForwardRef as ReactComponent };